const initialSettings = {
    tool: "Pen",   // or "Pen" if you prefer
    color: "#000000",
    background: "",
    strokeWidth: 1,
    strokeFill: "",
    strokeStyle: "",
    roughness: 0.7,
    toolId: 0,
};

export default initialSettings;
